import './SidebarMobile.css';
import './Sidebar.css';
import {Drawer,} from "@material-ui/core";
import hamburgerMenu from './image/category.svg'
import SidebarSmallSize from "./SidebarSmallSize";
import * as React from "react";
import raiko from "./image/profile_toolbar.svg";
import {NavLink} from "react-router-dom";
import {RouteInfo} from "../../route/RouteHelper";
import Exit from "./Exit";
import {useState} from "react";

const SidebarMobile = ({doLogout, sideBarListItems}) => {

    const [state, setState] = React.useState({
        left: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };

    const [openDialog, setOpenDialog] = useState(false)

    const handleClickOpen = () => {
        setOpenDialog(true)
    }
    const handleClose = () => {
        setOpenDialog(false)
    }

    return (
        <div className="header-content">
            {['left'].map((anchor) => (
                <React.Fragment key={anchor}>
                   <section className="d-flex flex-row w-100 alignItemsCenter">
                       <img width="32" height="32" className="menu-icon" src={hamburgerMenu} onClick={toggleDrawer(anchor, true)} alt="menu"/>
                       <span className="flex-grow-1">

                       </span>
                       <section className="profileContainer">
                           <section className="d-flex alignItemsCenter">
                               {/*<span className="px-2 fs-1">علی محی الدینی</span>*/}
                               <img className="profileImage" width="32" height="32" src={raiko} alt=""/>
                           </section>
                           <section className="profileToolbarContainer">
                               <ul>
                                   <li
                                       className={"profile_toolbar_item"}>
                                       <NavLink to={RouteInfo.Profile.url}>
                                           <section className={RouteInfo.Profile.icon}/>
                                           <span className="sidebar-title">{RouteInfo.Profile.name}</span>
                                       </NavLink>
                                   </li>
                                   <li
                                       className={"profile_toolbar_item alignItemsCenter"}>
                                       <section onClick={handleClickOpen}>
                                           <section className="logout-logo"/>
                                           <span className="sidebar-title">خروج</span>
                                       </section>
                                   </li>
                               </ul>
                               {
                                   <Exit
                                       openDialog={openDialog}
                                       setOpenDialog={setOpenDialog}
                                       handleClickOpen={handleClickOpen}
                                       handleClose={handleClose}
                                   />
                               }
                           </section>
                       </section>
                   </section>
                    <Drawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                    >
                        <SidebarSmallSize sideBarListItems={sideBarListItems}/>
                    </Drawer>
                </React.Fragment>
            ))}
        </div>
    )
}
export default SidebarMobile;